import { useState } from 'react'
import GoogleMapReact from 'google-map-react'
import LocationMarker from './LocationMarker'
import LocationInfoBox from './LocationInfoBox'
import EmailInfoBox from './EmailInfoBox'
import {Container, Row, Col} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import env from "react-dotenv";

const SearchMaps = ({books, latitude, longitude}) => {
    const [locationInfo, setLocationInfo] = useState(null)
    const [selectedBook, setSelectedBook] = useState([])
    const [emails, setEmails] = useState([]);
    const sentId = useSelector((state)=> state.mailsent);
    const markers = books.map((book, index) => {
        return <LocationMarker key={index} lat={book.latitude} lng={book.longitude} onClick={() => setLocationInfo(book)} />
    })
    let listIds = []
    sentId.map((sent)=>{
        listIds = listIds.concat(sent)
    })
    return (
        <Container>
            <Row>
                <Col sm={8}>
                    <div className="map">
                        <GoogleMapReact bootstrapURLKeys={{ key: env.GOOGLEAPI}}
                        defaultCenter={ {lat:latitude, lng:longitude,} }
                        defaultZoom={13}
                        >
                            {markers}
                        </GoogleMapReact>
                    </div>
                </Col>
                <Col sm={4}>
                    {<LocationInfoBox listIds = {listIds} books = {books} locationInfo={locationInfo} emails = {emails} setEmails = {setEmails} setSelectedBook = {setSelectedBook} selectedBook = {selectedBook}/>}
                    {<EmailInfoBox setSelectedBook = {setSelectedBook} selectedBook = {selectedBook}/>}
                </Col>
            </Row>
        </Container>       
    )
}

export default SearchMaps
